module.exports = __webpack_public_path__ + "static/media/fullPage.f382a508.jpg";